/**
 * Console error interceptor.
 * Patches console.error/warn and captures window error events
 * into a rolling buffer.
 */

import type { ConsoleEntry } from "../types";

const buffer: ConsoleEntry[] = [];
let maxEntries = 20;
let installed = false;

export function installConsoleInterceptor(max: number): void {
  if (installed) return;
  installed = true;
  maxEntries = max;

  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args: unknown[]) => {
    pushEntry("error", args);
    originalError.apply(console, args);
  };

  console.warn = (...args: unknown[]) => {
    pushEntry("warn", args);
    originalWarn.apply(console, args);
  };

  window.addEventListener("error", (event) => {
    pushEntry("error", [`${event.message} at ${event.filename}:${event.lineno}:${event.colno}`]);
  });

  window.addEventListener("unhandledrejection", (event) => {
    pushEntry("error", [`Unhandled rejection: ${event.reason}`]);
  });
}

function pushEntry(level: ConsoleEntry["level"], args: unknown[]): void {
  buffer.push({
    level,
    message: args.map(String).join(" ").slice(0, 500),
    timestamp: Date.now(),
  });
  if (buffer.length > maxEntries) {
    buffer.shift();
  }
}

export function getConsoleErrors(): ConsoleEntry[] {
  return [...buffer];
}
